import React from 'react';
export function ContactPage() {
  return <div className="bg-black" data-id="element-358">
      {/* Hero Section */}
      <section className="relative w-full bg-gradient-to-b from-gray-900 to-black py-20 px-4 sm:px-6 lg:px-8" data-id="element-359">
        <div className="max-w-5xl mx-auto text-center" data-id="element-360">
          <h1 className="text-4xl sm:text-5xl font-bold mb-6" data-id="element-361">
            Contact <span className="text-[#4a7c59]" data-id="element-362">Us</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-363">
            Have questions? We're here to help you on your journey to financial
            independence.
          </p>
        </div>
      </section>
      {/* Contact Form Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-900" data-id="element-364">
        <div className="max-w-3xl mx-auto" data-id="element-365">
          <form className="bg-black p-8 rounded-lg border border-[#4a7c59]" data-id="element-366">
            <div className="space-y-6" data-id="element-367">
              <div data-id="element-368">
                <label htmlFor="name" className="block text-sm font-medium mb-2" data-id="element-369">
                  First & Last Name
                </label>
                <input type="text" id="name" className="w-full px-4 py-2 bg-gray-900 border border-gray-800 rounded-md focus:outline-none focus:border-[#4a7c59]" required data-id="element-370" />
              </div>
              <div data-id="element-371">
                <label htmlFor="email" className="block text-sm font-medium mb-2" data-id="element-372">
                  Email
                </label>
                <input type="email" id="email" className="w-full px-4 py-2 bg-gray-900 border border-gray-800 rounded-md focus:outline-none focus:border-[#4a7c59]" required data-id="element-373" />
              </div>
              <div data-id="element-374">
                <label htmlFor="message" className="block text-sm font-medium mb-2" data-id="element-375">
                  Helpful Context / Message
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-2 bg-gray-900 border border-gray-800 rounded-md focus:outline-none focus:border-[#4a7c59]" required data-id="element-376"></textarea>
              </div>
              <button type="submit" className="w-full bg-[#4a7c59] hover:bg-[#3d6649] text-white font-bold py-3 px-8 rounded-md" data-id="element-377">
                Send Message
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>;
}